export const ACCTAG_LOADING = "ACCTAG_LOADING";
export const GET_ACCTAG = "GET_ACCTAG";
export const GET_ACCTAG_SUCCESS = "GET_ACCTAG_SUCCESS";
export const GET_ACCTAG_FAIL = "GET_ACCTAG_FAIL";
export const DELETE_ACCTAG = "DELETE_ACCTAG"
export const DELETE_ACCTAG_SUCCESS = "DELETE_ACCTAG_SUCCESS"
export const DELETE_ACCTAG_FAIL = "DELETE_ACCTAG_FAIL"
export const UPDATE_ACCTAG = "UPDATE_ACCTAG"
export const UPDATE_ACCTAG_SUCCESS = "UPDATE_ACCTAG_SUCCESS"
export const UPDATE_ACCTAG_FAIL = "UPDATE_ACCTAG_FAIL"
export const ADD_NEW_ACCTAG = "ADD_NEW_ACCTAG"
export const ADD_ACCTAG_SUCCESS = "ADD_ACCTAG_SUCCESS"
export const ADD_ACCTAG_FAIL = "ADD_ACCTAG_FAIL"